import { render, staticRenderFns } from "./UserUpdateScreen.vue?vue&type=template&id=6e71cff2&"
import script from "./UserUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./UserUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports